import { ExclamationCircleFilled } from "@ant-design/icons";
import { Alert, Button, Col, Modal, Row } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const { confirm } = Modal;

const CompanySelectorModal = ({ visible, companies, onSelect }) => {
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleCancel = (e) => {
        setOpen(false);
        confirm({
            title: "Veuillez confirmer",
            icon: <ExclamationCircleFilled />,
            content: "Voulez-vous vraiment vous déconnecter?",
            okText: "Se déconnecter",
            okType: "danger",
            cancelText: "Annuler",
            // Le modal parent est à zIndex 3000 → la confirmation doit passer AU-DESSUS.
            zIndex: 3100,
            onOk() {
                e.preventDefault();
                sessionStorage.removeItem("user");
                sessionStorage.removeItem("t");
                sessionStorage.removeItem("k");
                sessionStorage.removeItem("n");
                sessionStorage.removeItem("q");
                sessionStorage.removeItem("currentCompagnie");
                toast("Vous serez déconnecté");
                navigate("/connexion");
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const handleNew = () => {
        navigate("/soumettre-une-convention-de-collaboration");
    }
    return (
        <Modal
            title={companies.length > 0 ? "Sélectionnez la compagnie pour laquelle vous souhaitez travailler : " : "Vous n'avez pas encore été validé par une compagnie."}
            open={open || visible}
            closable={false}
            footer={[<Button type="primary" info onClick={handleNew}>Nouvelle Convention de coll.</Button>, <Button type="primary" danger onClick={handleCancel}>Se déconnecter</Button>]}
            maskClosable={false}
            zIndex={3000}
            centered
            width={900}
        >
            <Row gutter={[16, 16]} justify="center">
                {companies.length === 0 && <Alert showIcon message="Veuillez contacter un administrateur ou patienter encore quelques jours ouvrés." type="info" />}
                {companies.map((company) => (
                    <Col key={company.code} xs={12} sm={8} md={6} lg={6} xl={4}>
                        <div
                            onClick={() => {
                                onSelect(company);
                            }}
                            style={{
                                border: "1px solid #e8e8e8",
                                borderRadius: 8,
                                padding: 10,
                                textAlign: "center",
                                cursor: "pointer",
                                transition: "all 0.3s",
                                backgroundColor: "#fafafa",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)")}
                            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
                        >
                            <img
                                src={`data:image/png;base64,${company.logoDisplay}`}
                                alt={company.raisonSociale}
                                style={{ width: "80px", height: "80px", objectFit: "contain", marginBottom: 10 }}
                            />
                            <div style={{ fontWeight: "bold" }}>{company.raisonSociale}</div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Modal>
    );
};
export default CompanySelectorModal;